import { LoadersService } from './loaders.service';
import { LoaderActions } from './loader-actions.enum';
import { LoaderManagement } from './loader-management';
import { Injectable } from '@angular/core';
import { CommonModalService } from '../modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../modals/common-modal-templates.enum';
import { CommonInfoService } from '../../cart-process/common-info.service';

export class ModalLoaderData {
  public message = '';
  public preventClose = false;
  public templateName: CommonModalTemplatesEnum;

  constructor(
    message: string = '',
    preventClose: boolean = false,
    templateName: CommonModalTemplatesEnum = null,
  ) {
    this.message = message;
    this.preventClose = preventClose;
    this.templateName = templateName;
  }
}

@Injectable ()
export class ModalLoaderService {
  private initialized = false;
  private instantHide = false;
  private loadersService: LoadersService;

  constructor(
    private commonModalService: CommonModalService,
    private commonInfo: CommonInfoService
  ) {}

  public setLoaderService(loadersService: LoadersService): void {
    this.loadersService = loadersService;

    this.registerLoader();
  }

  public showModalLoader(modalLoaderData: ModalLoaderData): void {
    this.instantHide = false;
    const isVirginBrand = this.commonInfo.isVirginBrand;

    const modalData: any = {
      templateName: modalLoaderData.templateName ? modalLoaderData.templateName : CommonModalTemplatesEnum.MODAL_LOADER,
      init: () => {
        this.initialized = true;

        if (this.instantHide) {
          setTimeout(() => {
            this.hideLoader();
          });
        }
      },
      message: modalLoaderData.message || '',
      preventClose: modalLoaderData.preventClose || false,
      themeResourcePath: window['themeResourcePath'] || '',
      isVirginBrand
    };

    this.commonModalService.setData(modalData);
  }

  public hideLoader(): void {
    if (this.initialized) {
      this.commonModalService.removeModal(CommonModalTemplatesEnum.MODAL_LOADER);

    } else {
      this.instantHide = true;
    }
  }

  private registerLoader(): void {
    this.loadersService
      .registerLoader(LoaderActions.MODAL_LOADER)
      .subscribe((loader: LoaderManagement) => {
        if (loader.visible) {
          this.showModalLoader(loader.additionalData);
        }
        else {
          this.hideLoader();
        }
      });
  }
}
